import React from "react";
import { Table } from "react-bootstrap";

const AuditLogTable = () => {
  const auditLogs = [
    {
      timestamp: "2023-11-12 14:32:45",
      userId: "user123",
      action: "Login",
      target: "Dashboard",
      result: "Erfolgreich",
      sourceIp: "192.168.0.10",
    },
    {
      timestamp: "2023-11-12 14:35:22",
      userId: "user123",
      action: "Datei geändert",
      target: "/Daten/Finanzberichte.csv",
      result: "Erfolgreich",
      sourceIp: "192.168.0.10",
    },
    {
      timestamp: "2023-11-12 14:37:01",
      userId: "user456",
      action: "Zugriff verweigert",
      target: "/Daten/Personalakten.csv",
      result: "Fehlgeschlagen",
      sourceIp: "10.0.0.22",
    },
    {
      timestamp: "2023-11-12 14:40:10",
      userId: "user123",
      action: "Logout",
      target: "-",
      result: "Erfolgreich",
      sourceIp: "192.168.0.10",
    },
  ];

  return (
    <div className="container mt-4">
      <h5 className="text-center mb-4">Beispiel für eine Audit-Log-Liste </h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Zeitstempel</th>
            <th>Benutzer-ID</th>
            <th>Aktion</th>
            <th>Ziel</th>
            <th>Ergebnis</th>
            <th>Quelle-IP</th>
          </tr>
        </thead>
        <tbody>
          {auditLogs.map((log, index) => (
            <tr key={index}>
              <td>{log.timestamp}</td>
              <td>{log.userId}</td>
              <td>{log.action}</td>
              <td>{log.target}</td>
              <td>{log.result}</td>
              <td>{log.sourceIp}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default AuditLogTable;
